import React,{useRef} from "react";
// import bcrypt from "bcryptjs";
import './css/Nav design.css';

const PasswordEncrypt = () => {
    const usernameInputRef = useRef();
    const passwordInputRef = useRef();

    const SignUpForm = (e)=>{
        e.preventDefault();
        // const username = usernameInputRef.current.value;
        // const password = passwordInputRef.current.value;

        // const hashedPassword = bcrypt.hashSync(password,10);
        // window.localStorage.setItem('login',JSON.stringify({username,hashedPassword}))

        // console.log(password)
    }

        return(

<form className="form">
                    <div className='column'>
                    <label htmlFor="uname">Username </label>
                    <input type="text" id="uname" placeholder="Enter your Username" className="input-style" ref={usernameInputRef} />
                    

                        <br />

                    <label htmlFor="pass">Password</label>
                    <input type="text" id="pass" placeholder="password" className="input-style"   ref={passwordInputRef}/>
                    
                    

                    <button onClick={(e)=> SignUpForm(e)} type="button" className="button-styles"> Submit </button>
</div>
                </form>



        );
}
export default PasswordEncrypt;